import gql from 'graphql-tag';

export default gql`
  query overlayMerchandise($overlaySearchCriteria: MerchandiseOverlayInput) {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        merchandiseOverlay(overlaySearchCriteria: $overlaySearchCriteria) {
          content
          __typename
        }
        __typename
      }
    }
  }
`;
